import React, { useState } from 'react'
import Clevertap from 'analytics'
function LazyImg({ src, ph, type, ...rest }) {
    const [loaded, setLoaded] = useState(ph && false)
    function pushToCleverTap(img) {
        let imageName = ''
        if (img) {
            imageName = img.split('/').pop()
        }
        let fullPayload = {
            action_name: `marketing_banner_click`,
            url: imageName
        }
        Clevertap.event('Air_UI_Action', fullPayload)
    }

    return (
        <div style={type === 'video' ? {display: 'flex', height:'100%'} :{ display: 'flex' }} onClick={e => pushToCleverTap(ph)}>
            {type === 'video' ? (
                <video {...rest} style={{objectFit:'fill',borderRadius:'8px'}} autoPlay disablepictureinpicture loop muted playsinline>
                    <source src={src} type="video/mp4" />
                </video>
            ) : (
                <>
                    <img
                        loading="eager"
                        src={ph}
                        style={{ visibility: !loaded ? 'visible' : 'hidden' }}
                        alt=""
                        {...rest}
                    />
                    <img
                        loading="lazy"
                        src={src}
                        style={{
                            visibility: loaded ? 'visible' : 'hidden',
                            marginLeft: '-100%'
                        }}
                        onLoad={e => setLoaded(true)}
                        alt=""
                        {...rest}
                    />
                </>
            )}
        </div>
    )
}

export default LazyImg
